import type { ReactNode } from 'react';
import { Icon } from '@/components/foundations';

export type PaymentMethodRowProps = {
  icon: ReactNode;
  title: string;
  description: string;
  checked: boolean;
  onToggle: (checked: boolean) => void;
  id?: string;
};

/** Linha de método de pagamento do checkout (`.mrow`), ligada/desligada por checkbox. */
export function PaymentMethodRow({ icon, title, description, checked, onToggle, id }: PaymentMethodRowProps) {
  return (
    <div className="mrow">
      <input className="check" type="checkbox" checked={checked} aria-label={title} data-m={id} onChange={(e) => onToggle(e.target.checked)} />
      <span className="ic">{icon}</span>
      <span><b>{title}</b><small>{description}</small></span>
      <Icon name="down" />
    </div>
  );
}

/** Grupo de linhas (`.methods`). */
export function PaymentMethods({ children }: { children: ReactNode }) {
  return <div className="methods">{children}</div>;
}
